<div class="menu37"
    [ngClass]="{'menu--layout--classic': layout === 'classic', 'menu--layout--topbar': layout === 'topbar'}"
    #menuElement>
    <div class="row">
        <div class="col-12" *ngFor="let item of items">
            <ul class="menu__list">
                <li class="menu__item" style="text-align: start;">
                    <div style="overflow-x: hidden;"
                        *ngIf="((item.id == '103') || (item.id == '104') || (item.id == '105') || (item.id == '102')) ">
                        <b style="color: #ffffff; font-size: 17px;" class="mb-2"> {{ item.pageCaption }} :</b>
                        <div class="row">
                            <div class="col-3" *ngFor="let Subitem of item.subMenu">
                                <a [href]="Subitem.pageURL" target="_blank" rel="noopener noreferrer"
                                    (click)="gotoNav($event, Subitem.pageURL)">
                                    <ul class="menu__list sub" (click)="gotoNav($event, Subitem.pageURL)">
                                        <li style="margin-left: 25px;">
                                            <a [href]="Subitem.pageURL" target="_blank" rel="noopener noreferrer"
                                                (click)="gotoNav($event, Subitem.pageURL)" [id]="Subitem.id"
                                                style="border: none; background: transparent; color: #ffffff; text-decoration: none;">
                                                <i class="{{ Subitem.iconClass }}"></i>&nbsp; {{ Subitem.pageCaption }}
                                            </a>
                                        </li>
                                    </ul>
                                </a>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</div>